import { Flex } from '@chakra-ui/react';

export interface NotificationBannerProps {
    children: React.ReactNode;
    id?: string;
}
export const NotificationBanner = ({ children, id }: NotificationBannerProps) => (
    <Flex
        backgroundColor="slt-grey-light"
        padding="0.25rem 0.5rem"
        borderWidth={1}
        borderRadius={4}
        borderColor="slt-grey.1000"
        direction="column"
        gap={1}
        data-testid={id || 'notification-banner'}
    >
        {children}
    </Flex>
);
